<div bsModal #calendarModal="bs-modal" class="modal" tabindex="-1" role="dialog" class="modal fade" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ selectedDateType }}</h5>

        <button
          style="color: #111010"
          type="button"
          class="close pull-right btn-close"
          aria-label="Close"
          (click)="onCancel()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div style="padding: 0.8rem 0.8rem 0rem 0.8rem">
        <mat-tab-group
          class="small-tabs"
          [(selectedIndex)]="selectedTabIndex"
          (selectedIndexChange)="onTabChange([30, 60, 90][$event])">
          <mat-tab label="30 days"></mat-tab>
          <mat-tab label="60 days"></mat-tab>
          <mat-tab label="90 days"></mat-tab>
        </mat-tab-group>

        <mat-card style="margin-top: -6px; min-height: 380px">
          <mat-calendar #calendar [(selected)]="selected"> </mat-calendar>
        </mat-card>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary cancel-btn" (click)="onCancel()">Cancel</button>
        <button type="button" class="btn btn-primary save-btn" (click)="onSave()">Save</button>
      </div>
    </div>
  </div>
</div>
